import React, { useReducer } from "react";
import { Dispatch } from "react";
import { ACTIONS, initialState, reducer } from "./reducer";
import { IStoreType, State } from "./types";

type ContextProps = {
  status: string;
  loading: boolean;
  error: string | null;
  formStep: number;
  postcode: string;
  mp: {
    name: string;
    party: string;
    constituency: string;
    email: string;
    thumbnail: string;
  };
  formValues: {
    firstName: string;
    surname: string;
    email: string;
    address: string;
    postcode: string;
    subject: string;
    message: string;
    optIn: boolean | string;
    drivesEV: string;
    evDuration: string;
    evExperience: string;
    consideringEV: string;
    concerns: string[];
  };
  sendingEmail: boolean;
  dispatch: Dispatch<IStoreType>;
  handleGetMp: (postcode: string) => void;
  handleUpdateFormValues: (values: Partial<State["formValues"]>) => void;
  handleSetSendingEmail: (sending: boolean) => void;
};

const AppContext = React.createContext<Partial<ContextProps>>(initialState);

const AppProvider = ({ children }: { children: any }) => {
  const { Provider } = AppContext;
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleGetMp = (postcode: string) => {
    dispatch({ type: ACTIONS.DATA_REQUESTED, payload: postcode });
  };

  const handleUpdateFormValues = (values: Partial<State["formValues"]>) => {
    dispatch({ type: ACTIONS.UPDATE_FORM_VALUES, payload: values });
  };

  const handleSetSendingEmail = (sending: boolean) => {
    dispatch({ type: ACTIONS.SET_SENDING_EMAIL, payload: sending });
  };

  const value = {
    ...state,
    dispatch,
    handleGetMp,
    handleUpdateFormValues,
    handleSetSendingEmail,
  };

  return <Provider value={value}>{children}</Provider>;
};

export { AppContext, AppProvider };
